import {Component, inject, OnInit} from '@angular/core';
import {AuthService} from "../../../services/auth.service";
import {ToastService} from "../../../services/toast.service";
import {ActivatedRoute} from "@angular/router";

@Component({
  selector: 'app-email-verification',
  templateUrl: './email-verification.component.html',
  styleUrls: ['./email-verification.component.css'],
  standalone: false
})
export class EmailVerificationComponent implements OnInit {
  isVerified: boolean | null = null;

  private readonly route = inject(ActivatedRoute);
  private readonly authService = inject(AuthService);
  private readonly toastService = inject(ToastService);

  ngOnInit(): void {
    let token = this.route.snapshot.queryParams['token'];
    if (token == null) {
      this.toastService.showToast('Verification failed', 'error');
      this.isVerified = false;
    }
    this.authService.verifyEmail(token).then(
      (res: any) => this.handleVerification(res),
      (err: any) => this.handleError(err),
    );
  }

  private handleVerification(res: any) {
    if (res.isSuccess == false) {
      this.isVerified = false;
      this.toastService.showToast(res.error.error, 'error')
    } else {
      this.isVerified = true;
      this.isVerified = res.message == "Verification successful";
    }
  }

  handleError(err: any) {
    this.isVerified = false;
    this.toastService.showToast(err.error.error, 'error')
  }
}
